import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IReturnType } from '../interfaces';
import { ReturnTypeMapper } from '../mappers';

export type IGetReturnTypeByIdRepoResponse = IRepoResponse<200, IReturnType> | IRepoResponse<400 | 500, string>;

export type IGetReturnTypeByIdRepo = IRepo<[number | string], IGetReturnTypeByIdRepoResponse>;

export const GetReturnTypeByIdRepoType = Symbol.for('GetReturnTypeByIdRepo');

@bind(GetReturnTypeByIdRepoType)
export class GetReturnTypeByIdRepo implements IGetReturnTypeByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/return_reasons/info', { return_reason_id: id }) });

      if (result.status === 200) {
        const data: IReturnType = ReturnTypeMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
